/**
 *  This function creates a persistent cookie with a generated pseudo-GUID (for now, with a very simple algorithm.
 *  if we get collisions, we can improve it, or even create a service for it).
 *  If the user already has one, it will not be created, and we'll just fire a page-view event
 */
import * as uuid from 'uuid';
var PERSISTENT_COOKIE = '_ansPAID';
var ANSWERS_BASE_DOMAIN = '.wixanswers.com';
var DAY_IN_MS = 24 * 60 * 60 * 1000;
var PERSISTENCE_MILLISECONDS = 3 * 31 * DAY_IN_MS; // 3 months
var isWixAnswersDomain = function () { return document.location.host.indexOf(ANSWERS_BASE_DOMAIN) > -1; };
function readCookie(cookieName) {
    var results = document.cookie.match(new RegExp('\\b' + cookieName + '=(.*?)(;|$)'));
    if (results) {
        return (results[1]);
    }
    else {
        return null;
    }
}
function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export var ensureAnonId = function () {
    var oldCookieValue = readCookie(PERSISTENT_COOKIE);
    var newCookieValue = oldCookieValue || uuid();
    if (oldCookieValue) {
        deleteCookie(PERSISTENT_COOKIE);
    }
    var date = new Date();
    date.setTime(date.getTime() + PERSISTENCE_MILLISECONDS);
    var expires = '; expires=' + date.toGMTString();
    var maybeDomain = isWixAnswersDomain() ? "; domain=" + ANSWERS_BASE_DOMAIN : '';
    document.cookie = PERSISTENT_COOKIE + '=' + newCookieValue + expires + maybeDomain + ';';
    return readCookie(PERSISTENT_COOKIE);
};
export var getAnonId = ensureAnonId;
//# sourceMappingURL=pseudonymous-id.js.map